{
  "labels": {
    "paste": "Enganxa",
    "pasteAsPlaintext": "Enganxar com a text pla",
    "pasteCharts": "Enganxa els diagrames",
    "selectAll": "Selecciona-ho tot",
    "multiSelect": "Afegeix un element a la selecció",
    "moveCanvas": "Mou el llenç",
    "cut": "Retalla",
    "copy": "Copia",
    "copyAsPng": "Copia al porta-retalls com a PNG",
    "copyAsSvg": "Copia al porta-retalls com a SVG",
    "copyText": "Copia al porta-retalls com a text",
    "copySource": "Copia l'origen al porta-retalls",
    "convertToCode": "",
    "bringForward": "Porta endavant",
    "sendToBack": "Envia enrere",
    "bringToFront": "Porta al davant",
    "sendBackward": "Envia al fons",
    "delete": "Elimina",
    "copyStyles": "Copia els estils",
    "pasteStyles": "Enganxa els estils",
    "stroke": "Color del traç",
    "background": "Color del fons",
    "fill": "Estil del fons",
    "strokeWidth": "Amplada del traç",
    "strokeStyle": "Estil del traç",
    "strokeStyle_solid": "Sòlid",
    "strokeStyle_dashed": "Guions",
    "strokeStyle_dotted": "Punts",
    "sloppiness": "Estil del traç",
    "opacity": "Opacitat",
    "textAlign": "Alineació del text",
    "edges": "Vores",
    "sharp": "Agut",
    "round": "Arrodonit",
    "arrowheads": "Puntes de fletxa",
    "arrowhead_none": "Cap",
    "arrowhead_arrow": "Fletxa",
    "arrowhead_bar": "Barra",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Triangle",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Mida de lletra",
    "fontFamily": "Tipus de lletra",
    "addWatermark": "Afegeix-hi «Fet amb Excalidraw»",
    "handDrawn": "Dibuixat a mà",
    "normal": "Normal",
    "code": "Codi",
    "small": "Petit",
    "medium": "Mitjà",
    "large": "Gran",
    "veryLarge": "Molt gran",
    "solid": "Sòlid",
    "hachure": "Ratlletes",
    "zigzag": "",
    "crossHatch": "Ratlletes creuades",
    "thin": "Fi",
    "bold": "Negreta",
    "left": "Esquerra",
    "center": "Centre",
    "right": "Dreta",
    "extraBold": "Extra negreta",
    "architect": "Arquitecte",
    "artist": "Artista",
    "cartoonist": "Dibuixant",
    "fileTitle": "Nom del fitxer",
    "colorPicker": "Selector de colors",
    "canvasColors": "Usat al llenç",
    "canvasBackground": "Fons del llenç",
    "drawingCanvas": "Llenç de dibuix",
    "layers": "Capes",
    "actions": "Accions",
    "language": "Llengua",
    "liveCollaboration": "Col·laboració en directe...",
    "duplicateSelection": "Duplica",
    "untitled": "Sense títol",
    "name": "Nom",
    "yourName": "El vostre nom",
    "madeWithExcalidraw": "Fet amb Excalidraw",
    "group": "Agrupa la selecció",
    "ungroup": "Desagrupa la selecció",
    "collaborators": "Col·laboradors",
    "showGrid": "Mostra la graella",
    "addToLibrary": "Afegir a la biblioteca",
    "removeFromLibrary": "Eliminar de la biblioteca",
    "libraryLoadingMessage": "S'està carregant la biblioteca…",
    "libraries": "Explora les biblioteques",
    "loadingScene": "S'està carregant l'escena…",
    "align": "Alinea",
    "alignTop": "Alinea a la part superior",
    "alignBottom": "Alinea a la part inferior",
    "alignLeft": "Alinea a l’esquerra",
    "alignRight": "Alinea a la dreta",
    "centerVertically": "Centra verticalment",
    "centerHorizontally": "Centra horitzontalment",
    "distributeHorizontally": "Distribueix horitzontalment",
    "distributeVertically": "Distribueix verticalment",
    "flipHorizontal": "Capgira horitzontalment",
    "flipVertical": "Capgira verticalment",
    "viewMode": "Mode de visualització",
    "share": "Comparteix",
    "showStroke": "Mostra el selector de color del traç",
    "showBackground": "Mostra el selector de color de fons",
    "toggleTheme": "Activa o desactiva el tema",
    "personalLib": "Biblioteca personal",
    "excalidrawLib": "Biblioteca d'Excalidraw",
    "decreaseFontSize": "Redueix la mida de la lletra",
    "increaseFontSize": "Augmenta la mida de la lletra",
    "unbindText": "Desvincular el text",
    "bindText": "Ajusta el text al contenidor",
    "createContainerFromText": "",
    "link": {
      "edit": "Edita l'enllaç",
      "editEmbed": "Edita l'enllaç i incrusta-ho",
      "create": "Crea un enllaç",
      "createEmbed": "",
      "label": "Enllaç",
      "labelEmbed": "",
      "empty": "No s'ha definit cap enllaç"
    },
    "lineEditor": {
      "edit": "Editar línia",
      "exit": "Sortir de l'editor de línia"
    },
    "elementLock": {
      "lock": "Bloca",
      "unlock": "Desbloca",
      "lockAll": "Bloca-ho tot",
      "unlockAll": "Desbloca-ho tot"
    },
    "statusPublished": "Publicat",
    "sidebarLock": "Manté la barra lateral oberta",
    "selectAllElementsInFrame": "Selecciona tots els elements del marc",
    "removeAllElementsFromFrame": "Eliminat tots els elements del marc",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Encara no s'hi han afegit elements...",
    "hint_emptyLibrary": "Trieu un element o un llenç per a afegir-lo aquí, o instal·leu una biblioteca del repositori públic, més avall.",
    "hint_emptyPrivateLibrary": "Trieu un element o un llenç per a afegir-lo aquí."
  },
  "buttons": {
    "clearReset": "Neteja el llenç",
    "exportJSON": "Exporta a un fitxer",
    "exportImage": "Exporta la imatge...",
    "export": "Guardar a...",
    "copyToClipboard": "Copia al porta-retalls",
    "save": "Desa al fitxer actual",
    "saveAs": "Anomena i desa",
    "load": "Obrir",
    "getShareableLink": "Obté l'enllaç per a compartir",
    "close": "Tanca",
    "selectLanguage": "Trieu la llengua",
    "scrollBackToContent": "Torna al contingut",
    "zoomIn": "Apropa't",
    "zoomOut": "Allunya't",
    "resetZoom": "Restableix el zoom",
    "menu": "Menú",
    "done": "Fet",
    "edit": "Edita",
    "undo": "Desfés",
    "redo": "Refés",
    "resetLibrary": "Restableix la biblioteca",
    "createNewRoom": "Crea una sala nova",
    "fullScreen": "Pantalla completa",
    "darkMode": "Mode fosc",
    "lightMode": "Mode clar",
    "zenMode": "Mode zen",
    "objectsSnapMode": "",
    "exitZenMode": "Surt de mode zen",
    "cancel": "Cancel·la",
    "clear": "Neteja",
    "remove": "Suprimeix",
    "embed": "",
    "publishLibrary": "Publica",
    "submit": "Envia",
    "confirm": "Confirma",
    "embeddableInteractionButton": "Feu clic per interactuar"
  },
  "alerts": {
    "clearReset": "S'esborrarà tot el llenç. N'esteu segur?",
    "couldNotCreateShareableLink": "No s'ha pogut crear un enllaç per a compartir.",
    "couldNotCreateShareableLinkTooBig": "No s’ha pogut crear un enllaç per a compartir: l’escena és massa gran",
    "couldNotLoadInvalidFile": "No s'ha pogut carregar un fitxer no vàlid",
    "importBackendFailed": "Importació fallida.",
    "cannotExportEmptyCanvas": "No es pot exportar un llenç buit.",
    "couldNotCopyToClipboard": "No s'ha pogut copiar al porta-retalls.",
    "decryptFailed": "No s'ha pogut desencriptar.",
    "uploadedSecurly": "La càrrega s'ha assegurat amb xifratge punta a punta, cosa que significa que el servidor Excalidraw i tercers no poden llegir el contingut.",
    "loadSceneOverridePrompt": "Si carregas aquest dibuix extern, substituirá el que tens. Vols continuar?",
    "collabStopOverridePrompt": "Aturar la sessió provocarà la sobreescriptura del dibuix previ, que hi ha desat en l'emmagatzematge local. N'esteu segur?\n\n(Si voleu conservar el dibuix local, tanqueu la pentanya del navegador en comptes d'aturar la sessió).",
    "errorAddingToLibrary": "No s'ha pogut afegir l'element a la biblioteca",
    "errorRemovingFromLibrary": "No s'ha pogut eliminar l'element de la biblioteca",
    "confirmAddLibrary": "Això afegirà {{numShapes}} forma(es) a la vostra biblioteca. Estàs segur?",
    "imageDoesNotContainScene": "Aquesta imatge no sembla contenir cap dada d'escena. Heu activat l'incrustació de l'escena durant l'exportació?",
    "cannotRestoreFromImage": "L’escena no s’ha pogut restaurar des d’aquest fitxer d’imatge",
    "invalidSceneUrl": "No s'ha pogut importar l'escena des de l'adreça URL proporcionada. Està malformada o no conté dades Excalidraw JSON vàlides.",
    "resetLibrary": "Això buidarà la biblioteca. N'esteu segur?",
    "removeItemsFromsLibrary": "Suprimir {{count}} element(s) de la biblioteca?",
    "invalidEncryptionKey": "La clau d'encriptació ha de tenir 22 caràcters. La col·laboració en directe està desactivada.",
    "collabOfflineWarning": "Sense connexió a internet disponible.\nEls vostres canvis no seran guardats!"
  },
  "errors": {
    "unsupportedFileType": "Tipus de fitxer no suportat.",
    "imageInsertError": "No s'ha pogut insertar la imatge, torneu-ho a provar més tard...",
    "fileTooBig": "El fitxer és massa gros. La mida màxima permesa és {{maxSize}}.",
    "svgImageInsertError": "No ha estat possible inserir la imatge SVG. Les marques SVG semblen invàlides.",
    "failedToFetchImage": "",
    "invalidSVGString": "SVG no vàlid.",
    "cannotResolveCollabServer": "No ha estat possible connectar amb el servidor collab. Si us plau recarregueu la pàgina i torneu a provar.",
    "importLibraryError": "No s'ha pogut carregar la biblioteca",
    "collabSaveFailed": "No s'ha pogut desar a la base de dades de fons. Si els problemes persisteixen, hauríeu de desar el fitxer localment per assegurar-vos que no perdeu el vostre treball.",
    "collabSaveFailed_sizeExceeded": "No s'ha pogut desar a la base de dades de fons, sembla que el llenç és massa gran. Hauríeu de desar el fitxer localment per assegurar-vos que no perdeu el vostre treball.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "No s'ha pogut enganxar.",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Selecció",
    "image": "Insereix imatge",
    "rectangle": "Rectangle",
    "diamond": "Rombe",
    "ellipse": "El·lipse",
    "arrow": "Fletxa",
    "line": "Línia",
    "freedraw": "Dibuix",
    "text": "Text",
    "library": "Biblioteca",
    "lock": "Mantenir activa l'eina seleccionada desprès de dibuixar",
    "penMode": "Mode de llapis - evita tocar",
    "link": "Afegeix / actualitza l'enllaç per a la forma seleccionada",
    "eraser": "Esborrador",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "Mà (eina de desplaçament)",
    "extraTools": "",
    "mermaidToExcalidraw": "De Mermaid a Excalidraw",
    "magicSettings": "Preferències d'IA"
  },
  "headings": {
    "canvasActions": "Accions del llenç",
    "selectedShapeActions": "Accions per a les formes seleccionades",
    "shapes": "Formes"
  },
  "hints": {
    "canvasPanning": "Per moure el llenç, manteniu premuda la roda del ratolí o la barra espaiadora mentre arrossegueu o utilitzeu l'eina manual",
    "linearElement": "Feu clic per a dibuixar múltiples punts; arrossegueu per a una sola línia",
    "freeDraw": "Feu clic i arrossegueu, deixeu anar per a finalitzar",
    "text": "Consell: també podeu afegir text fent doble clic en qualsevol lloc amb l'eina de selecció",
    "embeddable": "",
    "text_selected": "Feu doble clic o premeu Retorn per a editar el text",
    "text_editing": "Premeu Escapada o Ctrl+Retorn (o Ordre+Retorn) per a finalitzar l'edició",
    "linearElementMulti": "Feu clic a l'ultim punt, o pitgeu Esc o Retorn per a finalitzar",
    "lockAngle": "Per restringir els angles, mantenir premut el majúscul (SHIFT)",
    "resize": "Per restringir les proporcions mentres es canvia la mida, mantenir premut el majúscul (SHIFT); per canviar la mida des del centre, mantenir premut ALT",
    "resizeImage": "Podeu redimensionar lliurement prement MAJÚSCULA;\nper a redimensionar des del centre, premeu ALT",
    "rotate": "Per restringir els angles mentre gira, mantenir premut el majúscul (SHIFT)",
    "lineEditor_info": "Mantingueu premut Ctrl o Cmd i feu doble clic o premeu Ctrl o Cmd + Retorn per editar els punts",
    "lineEditor_pointSelected": "Premeu Suprimir per a eliminar el(s) punt(s), CtrlOrCmd+D per a duplicar-lo, o arrossegueu-lo per a moure'l",
    "lineEditor_nothingSelected": "Seleccioneu un punt per a editar-lo (premeu SHIFT si voleu\nselecció múltiple), o manteniu Alt i feu clic per a afegir més punts",
    "placeImage": "Feu clic per a col·locar la imatge o clic i arrossegar per a establir-ne la mida manualment",
    "publishLibrary": "Publiqueu la vostra pròpia llibreria",
    "bindTextToElement": "Premeu enter per a afegir-hi text",
    "deepBoxSelect": "Manteniu CtrlOrCmd per a selecció profunda, i per a evitar l'arrossegament",
    "eraserRevert": "Mantingueu premuda Alt per a revertir els elements seleccionats per a esborrar",
    "firefox_clipboard_write": "És probable que aquesta funció es pugui activar posant la marca \"dom.events.asyncClipboard.clipboardItem\" a \"true\". Per canviar les marques del navegador al Firefox, visiteu la pàgina \"about:config\".",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "No es pot mostrar la previsualització",
    "canvasTooBig": "Pot ser que el llenç sigui massa gran.",
    "canvasTooBigTip": "Consell: proveu d’acostar una mica els elements més allunyats."
  },
  "errorSplash": {
    "headingMain": "S'ha produït un error. Proveu <button>recarregar la pàgina.</button>",
    "clearCanvasMessage": "Si la recàrrega no funciona, proveu <button>esborrar el llenç.</button>",
    "clearCanvasCaveat": " Això resultarà en la pèrdua de feina ",
    "trackedToSentry": "L'error amb l'identificador {{eventId}} s'ha rastrejat en el nostre sistema.",
    "openIssueMessage": "Anàvem amb molta cura de no incloure la informació de la vostra escena en l'error. Si l'escena no és privada, podeu fer-ne el seguiment al nostre <button>rastrejador d'errors.</button> Incloeu la informació a continuació copiant i enganxant a GitHub Issues.",
    "sceneContent": "Contingut de l'escena:"
  },
  "roomDialog": {
    "desc_intro": "Podeu convidar persones a la vostra escena actual a col·laborar amb vós.",
    "desc_privacy": "No us preocupeu, la sessió utilitza el xifratge de punta a punta, de manera que qualsevol cosa que dibuixeu romandrà privada. Ni tan sols el nostre servidor podrà veure què feu.",
    "button_startSession": "Inicia la sessió",
    "button_stopSession": "Atura la sessió",
    "desc_inProgressIntro": "La sessió de col·laboració en directe està en marxa.",
    "desc_shareLink": "Comparteix aquest enllaç amb qualsevol persona amb qui vulgueu col·laborar:",
    "desc_exitSession": "Si atureu la sessió, us desconectareu de la sala, però podreu continuar treballant amb el dibuix localment. Tingues en compte que això no afectarà a altres persones, i encara podran col·laborar en la seva versió.",
    "shareTitle": "Uniu-vos a una sessió de col·laboració en directe a Excalidraw"
  },
  "errorDialog": {
    "title": "Error"
  },
  "exportDialog": {
    "disk_title": "Desa al disc",
    "disk_details": "Exporta les dades de l'escena a un fitxer que després podreu importar.",
    "disk_button": "Desa en un fitxer",
    "link_title": "Enllaç per a compartir",
    "link_details": "Exporta com a un enllaç de només lectura.",
    "link_button": "Exporta a un enllaç",
    "excalidrawplus_description": "Desa l'escena en el vostre espai de treball Excalidraw+.",
    "excalidrawplus_button": "Exporta",
    "excalidrawplus_exportError": "No és possible exportar a Excalidraw+ ara mateix..."
  },
  "helpDialog": {
    "blog": "Llegiu el nostre blog",
    "click": "clic",
    "deepSelect": "Selecció profunda",
    "deepBoxSelect": "Seleccioneu profundament dins del quadre i eviteu arrossegar",
    "curvedArrow": "Fletxa corba",
    "curvedLine": "Línia corba",
    "documentation": "Documentació",
    "doubleClick": "doble clic",
    "drag": "arrossega",
    "editor": "Editor",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Hi heu trobat un problema? Informeu-ne",
    "howto": "Seguiu les nostres guies",
    "or": "o",
    "preventBinding": "Prevenir vinculació de la fletxa",
    "tools": "Eines",
    "shortcuts": "Dreceres de teclat",
    "textFinish": "Finalitza l'edició (editor de text)",
    "textNewLine": "Afegeix una línia nova (editor de text)",
    "title": "Ajuda",
    "view": "Visualització",
    "zoomToFit": "Zoom per veure tots els elements",
    "zoomToSelection": "Zoom per veure la selecció",
    "toggleElementLock": "Blocar/desblocar la selecció",
    "movePageUpDown": "Mou la pàgina cap amunt/a baix",
    "movePageLeftRight": "Mou la pàgina cap a l'esquerra/dreta"
  },
  "clearCanvasDialog": {
    "title": "Neteja el llenç"
  },
  "publishDialog": {
    "title": "Publica la biblioteca",
    "itemName": "Nom de l'element",
    "authorName": "Nom de l'autor/a",
    "githubUsername": "Nom d'usuari de GitHub",
    "twitterUsername": "Nom d'usuari de Twitter",
    "libraryName": "Nom de la biblioteca",
    "libraryDesc": "Descripció de la biblioteca",
    "website": "Lloc web",
    "placeholder": {
      "authorName": "Nom o usuari",
      "libraryName": "Nom de la vostra biblioteca",
      "libraryDesc": "Descripció de la biblioteca per a ajudar a la gent a entendre'n el funcionament",
      "githubHandle": "Identificador de GitHub (opcional), per tal que pugueu editar la biblioteca una vegada enviada per a ser revisada",
      "twitterHandle": "Usuari de twitter (opcional), per tal que puguem donar-vos crèdit quan fem la promoció a Twitter",
      "website": "Enllaç al vostre lloc web personal o a qualsevol altre (opcional)"
    },
    "errors": {
      "required": "Requerit",
      "website": "Introduïu una URL vàlida"
    },
    "noteDescription": "Envieu la vostra biblioteca perquè sigui inclosa al <link>repositori públic</link>per tal que altres persones puguin fer-ne ús en els seus dibuixos.",
    "noteGuidelines": "La biblioteca ha de ser aprovada manualment. Si us plau, llegiu les <link>directrius</link> abans d'enviar-hi res. Necessitareu un compte de GitHub per a comunicar i fer-hi canvis si cal, però no és requisit imprescindible.",
    "noteLicense": "Quan l'envieu, accepteu que la biblioteca sigui publicada sota la <link>llicència MIT, </link>que, en resum, vol dir que qualsevol persona pot fer-ne ús sense restriccions.",
    "noteItems": "Cada element de la biblioteca ha de tenir el seu propi nom per tal que sigui filtrable. S'hi inclouran els elements següents:",
    "atleastOneLibItem": "Si us plau, seleccioneu si més no un element de la biblioteca per a començar",
    "republishWarning": "Nota: alguns dels elements seleccionats s'han marcat com a publicats/enviats. Només hauríeu de reenviar elements quan actualitzeu una biblioteca existent."
  },
  "publishSuccessDialog": {
    "title": "Biblioteca enviada",
    "content": "Gràcies, {{authorName}}. La vostra biblioteca ha estat enviada per a ser revisada. Podeu comprovar-ne l'estat<link>aquí</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Restableix la biblioteca",
    "removeItemsFromLib": "Suprimeix els elements seleccionats de la llibreria"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "Només els seleccionats",
      "darkMode": "Mode fosc",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "Exporta a PNG",
      "exportToSvg": "Exporta a SVG",
      "copyPngToClipboard": "Copia el PNG al porta-retalls"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "Els vostres dibuixos estan xifrats de punta a punta de manera que els servidors d’Excalidraw no els veuran mai.",
    "link": "Article del blog sobre encriptació d'extrem a extrem a Excalidraw"
  },
  "stats": {
    "angle": "Angle",
    "element": "Element",
    "elements": "Elements",
    "height": "Altura",
    "scene": "Escena",
    "selected": "Seleccionat",
    "storage": "Emmagatzematge",
    "title": "Estadístiques per nerds",
    "total": "Total",
    "version": "Versió",
    "versionCopy": "Feu clic per a copiar",
    "versionNotAvailable": "Versió no disponible",
    "width": "Amplada"
  },
  "toast": {
    "addedToLibrary": "Afegit a la biblioteca",
    "copyStyles": "S'han copiat els estils.",
    "copyToClipboard": "S'ha copiat al porta-retalls.",
    "copyToClipboardAsPng": "S'ha copiat {{exportSelection}} al porta-retalls en format PNG\n({{exportColorScheme}})",
    "fileSaved": "S'ha desat el fitxer.",
    "fileSavedToFilename": "S'ha desat a {filename}",
    "canvas": "el llenç",
    "selection": "la selecció",
    "pasteAsSingleElement": "Fer servir {{shortcut}} per enganxar com un sol element,\no enganxeu-lo en un editor de text existent",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "Transparent",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "Verd",
    "yellow": "Groc",
    "orange": "Taronja",
    "bronze": "Bronze"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Totes les vostres dades es guarden localment al vostre navegador.",
      "center_heading_plus": "Vols anar a Excalidraw+ en comptes?",
      "menuHint": "Exportar, preferències, llenguatges..."
    },
    "defaults": {
      "menuHint": "Exportar, preferències i més...",
      "center_heading": "Diagrames. Fer. Simple.",
      "toolbarHint": "Selecciona una eina i comença a dibuixar!",
      "helpHint": "Dreceres i ajuda"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exporta com a imatge",
        "button": "Exporta com a imatge",
        "description": ""
      },
      "saveToDisk": {
        "title": "Desa al disc",
        "button": "Desa al disc",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Carrega des d'un fitxer",
        "button": "Carrega des d'un fitxer",
        "description": ""
      },
      "shareableLink": {
        "title": "Carrega des d'un enllaç",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "De Mermaid a Excalidraw",
    "button": "Insereix",
    "description": "",
    "syntax": "Sintaxi de Mermaid",
    "preview": "Previsualització"
  }
}
